const inactivityPopup = document.querySelector('.user-interacion-popup-form');

const setCookie = (days) => {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    
    const expires = "expires=" + date.toUTCString();
    document.cookie = "interaction-popup=true;" + expires + ";path=/";
}

const checkCookie = () => {
    const cookie = document.cookie
      .split(';')
      .find(row => row.trim().startsWith('interaction-popup='));

    return cookie ? true : false;
}

const hidePopup = () => {
    inactivityPopup.classList.remove('show');
    setCookie(1);
}

const showPopup = () => {
    inactivityPopup.classList.add('show');
    inactivityPopup.querySelector('.close-icon').addEventListener('click', () => {
        hidePopup();
    })
}

const trackInactivity = () => {
    if (!inactivityPopup) return;

    let inactivityTimer;
    const INACTIVITY_TIMEOUT = 30000;

    const resetInactivityTimer = function() {
        clearTimeout(inactivityTimer);
        inactivityTimer = setTimeout(function() {
            if (!checkCookie()) {
                showPopup();
                cleanup();
            }
        }, INACTIVITY_TIMEOUT);
   };

    const trackUserActivity = function() {
        const events = [
            'mousedown',
            'mousemove',
            'keypress',
            'scroll',
            'touchstart',
            'click',
            'keydown'
        ];

        events.forEach(function(event) {
            document.addEventListener(event, resetInactivityTimer);
        });

        resetInactivityTimer();
      };

      const cleanup = function() {
        clearTimeout(inactivityTimer);
        const events = [
            'mousedown',
            'mousemove',
            'keypress',
            'scroll',
            'touchstart',
            'click',
            'keydown'
        ];

        events.forEach(function(event) {
            document.removeEventListener(event, resetInactivityTimer);
        });
    };

    trackUserActivity();
}

const exitTriggers = () => {
    var backTrigger = document.querySelector('#exit-trigger-left');
    var closeTrigger = document.querySelector('#exit-trigger-right');

    if (!backTrigger || !closeTrigger) return;

    if (checkCookie() || $(window).width() < 768) return;

    backTrigger.addEventListener('mouseover', function() {
        showPopup();
    });

    closeTrigger.addEventListener('mouseover', function() {
        showPopup();
    });
}

document.addEventListener('DOMContentLoaded', trackInactivity);
document.addEventListener('DOMContentLoaded', exitTriggers);